import {
  CLICK_ACTION_ERROR,
  ELEMENT_ERROR_TEXT,
} from '@common/constants/common.constant';
import { RootState } from '../store';
import { getMessage } from '@common/constants/locale';

export const formInputs = (state: RootState) => state.formInputs;

export const getValueFields = (state: RootState) => state.formInputs.values;

export const formValueSelector = (state: RootState) =>
  state.formInputs.formValue;

export const inputIdFocusSelector = (state: RootState) =>
  state.formInputs.inputIdFocus;

export const getDefaultValueFields = (state: RootState) =>
  state.formInputs.defaultValues;

export const getInputsErrorSelector = (state: RootState) =>
  state.formInputs.inputError;

export const getInputErrorSelector =
  (inputId: string) =>
  (state: RootState): string | null => {
    const locale = state.language.locale || 'ja';
    const errorCode = state.formInputs.inputError[inputId];
    if (!errorCode) {
      return null;
    }
    switch (errorCode) {
      case CLICK_ACTION_ERROR.REQUIRED_VALUE:
        // get error from custom error message is a higher priority than the error code
        return (
          state.formInputs.errorMessages[inputId]?.mandatory ||
          getMessage({ id: ELEMENT_ERROR_TEXT[errorCode], locale })
        );
      default:
        return (
          getMessage({ id: ELEMENT_ERROR_TEXT[errorCode], locale }) || errorCode
        );
    }
  };
